import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'cc-mapping-description',
  templateUrl: './mapping-description.component.html',
  styleUrls: ['./mapping-description.component.scss']
})
export class MappingDescriptionComponent implements OnInit {
  @Input() classState;
  @Input() title;
  @Input() description;
  constructor() {}

  ngOnInit() {}
}
